<div class="w-full mx-auto mt-8 rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <p class="titre2">{{ 'TAGS_MANAGEMENT.MODIFY_ETIQUETTE' | translate }}</p>
  </div>
  <form (ngSubmit)="saveEtiquette()" class="flex flex-col flex-1 min-h-0">
    <div class="flex-1 overflow-y-auto p-4">
      @for (lang of LANGS; track lang) {
        <div class="mb-4">
          <label [for]="'nom_' + lang" class="block text-sm font-medium mb-1">
            {{ ('TAGS_MANAGEMENT.NAME_' + lang.toUpperCase()) | translate }}:
          </label>
          <input title="langue" type="text" [id]="'nom_' + lang" [(ngModel)]="etiquetteLocales[lang]"
            [name]="'nom_' + lang" required
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
        }
        <div class="mb-4">
          <label for="couleur" class="block text-sm font-medium mb-1">{{ 'TAGS_MANAGEMENT.COLOR' |
          translate }}:</label>
          <input type="color" id="couleur" [(ngModel)]="etiquette.couleur" name="couleur" required
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div class="mb-4">
            <label class="block text-sm font-medium mb-1">{{ 'TAGS_MANAGEMENT.ENTITIES' | translate
            }}:</label>
            <div class="mt-2">
              <ul class="list-disc list-inside">
                @for (entite of entitesSelectionnees; track entite) {
                  <li>
                    {{ entite.nom }}
                  </li>
                }
              </ul>
            </div>
          </div>
          <div class="mb-4">
            <label class="flex items-center">
              <input type="checkbox" [(ngModel)]="etiquette.visibleSurCertificats" name="visibleSurCertificats"
                class="form-checkbox h-5 w-5 text-rougeNovo border-gray-300 rounded mr-2 focus:outline-none focus:ring-0">
                <span>{{ 'TAGS_MANAGEMENT.VISIBLE_ON_CERTIFICATES' | translate }}</span>
              </label>
            </div>
          </div>
          <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end gap-6">
            <button type="button" (click)="closeDialog()" class="btn-secondary-novo">
              {{ 'TAGS_MANAGEMENT.CANCEL' | translate }}
            </button>
            <button type="submit" [disabled]="boutonSauvegardeDesactive() || estEnCoursDeEnregistrement"
              class="btn-primary-novo focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
              @if (!estEnCoursDeEnregistrement) {
                {{ 'TAGS_MANAGEMENT.SAVE' | translate }}
              }
              @if (estEnCoursDeEnregistrement) {
                <mat-spinner diameter="20" class="inline-block"></mat-spinner>
              }
            </button>
          </div>
        </form>
      </div>